import dayjs from "dayjs";
/**
 * Filename utility for event export
 * @param contentName Name for file's content. Required
 * @param referenceCodeForDisplay Event's shortCode or referenceCode.
 * @returns eg "masterlist-2023_CSI_3443-2024-05-15"
 */
export function exportEventFilenameUtility(contentName, referenceCodeForDisplay) {
    return `${[contentName, referenceCodeForDisplay]
        .filter(Boolean)
        .join("-")}-${dayjs().format("YYYY-MM-DD")}`;
}
